<template>
  <div ref="BigScreenDisplay" class="data-center">
    <!-- 布局头部 -->
    <div class="header bg1">
      <div class="path-left">
        <img
          src="../../../assets/images/bigScreen/equipment/goHome.png"
          @click="handleGoPath('/SCProjectHall')"
          style="width: 0.3rem"
          class="go-home"
          alt=""
          srcset=""
        />
        <img @click="handleGoPath()"
          src="@/assets/images/OperationBigScreen/DeploymentControl/back.png"
          class="go-home"
          style="margin-left: 0.3rem; margin-right: 0"
          alt=""
          srcset=""
        />
      </div>
      <!-- <div class="header_text_weather">
        <i class="el-icon-location"></i>
        <span style="margin-left: 0.5em">{{ weatherArea }}</span>
        <img class="header_weather" :src="weatherImg" alt="" />
        <span style="margin-left: 0.1em">{{ weatherText }}</span>
      </div> -->
      <span style="flex: 1"></span>
      <div class="header-title p-clip">一立云数据监控中心</div>
      <span class="time-pane">
        {{ dateText }}
        <span style="margin: 0 0.5em">{{ dayNum }}</span>
        {{ timeStr }}
      </span>

      <div class="path-right">
        <img @click="SetFullscreen"
          src="@/assets/images/OperationBigScreen/DeploymentControl/enlarge.png"
          class="go-home"
          style="margin-left: 0.3rem; margin-right: 0"
          alt=""
          srcset=""
        />
      </div>
    </div>

    <!-- 布局中间部分 -->
    <div class="MainOuter">
      <pzMenu @changeSelect="e=> menuData = e" />
      <pzTable :menuData="menuData" />
    </div>
  </div>
</template>
<script>
import { weatherInfo, amapGetIp } from "@/api/weather";
import { getWeek, getTimes } from "@/utils/getDate";
import pzMenu from "@/views/OperationBigScreen/maintenanceConfiguration/components/pzMenu";
import pzTable from "@/views/OperationBigScreen/maintenanceConfiguration/components/pzTable";
import dayjs from "dayjs";
import { mapMutations } from "vuex";

export default {
  // `name`与路由保持一致
  name: "SCProjectHall",
  components: { pzMenu, pzTable },
  data() {
    // this.intervalId = null;
    return {
      timeStr: "", // 时间
      timer: null, // 时间定时器
      loading: false, //加载
      weatherText: "", //天气说明
      weatherImg: "", //天气图标
      weatherArea: "", //天气地址
      vehicleTotal: 0,
      fullscreenchange: null,
      visibilitychange: null,
      backLoading: false,
      intervalId: null,
      dayNum: "",
      dateText: "",
      centerLng: null,
      zoom: 10,
      markerOffset: [0, 0],
      infoVisible: false, //
      currentVehicle: null,
      menuData: '1-1'
    };
  },
  created() {},
  // mounted
  activated() {
    let that = this;
    this.init();
    this.handleGetWeather();
    var datas = dayjs().day();
    var week = ["日", "一", "二", "三", "四", "五", "六"];
    this.dayNum = "周" + week[datas];
    this.dateText = dayjs().format("YYYY-MM-DD");
    this.timer = setInterval(() => {
      const today = dayjs(new Date()).format("HH:mm:ss");
      this.timeStr = `${today}`;
    }, 1000);

    // this.intervalId = setInterval(async () => {
    //   await this.init();
    // }, 1000 * 30);
    this.fullscreenchange = true;
    addEventListener("fullscreenchange", this.handleFullscreenchange);
    addEventListener("visibilitychange", this.handleVisibilitychange);
  },
  // destroyed
  deactivated() {
    clearInterval(this.timer); //销毁定时器
    // clearInterval(this.intervalId);
    clearTimeout(this.intervalId);
    this.intervalId = null;
    this.fullscreenchange = null;
    removeEventListener("fullscreenchange", this.handleFullscreenchange);
    removeEventListener("visibilitychange", this.handleVisibilitychange);
  },
  computed: {
  },

  methods: {
    async init() {},
    handleFullscreenchange() {
      this.init();
    },
    handleVisibilitychange() {
      if (document.visibilityState == "hidden") {
        clearTimeout(this.intervalId);
        this.intervalId = null;
      } else {
        this.init();
        if (!this.intervalId) {
          this.handlePolling();
        }
      }
    },
    handlePolling() {
      // this.intervalId = setTimeout(async () => {
      //   await this.init();
      //   clearTimeout(this.intervalId);
      //   if (this.fullscreenchange) {
      //     this.handlePolling();
      //   }
      // }, 1000 * 60);
    },
    getFullScreenEl() {
      const { el } = this;
      // return (isElement('el')
      //   ? el
      //   : document.querySelector(el)) || document.documentElement;
      return this.$refs["BigScreenDisplay"];
    },
    /**
     * 进入全屏
     */
    requestFullscreen() {
      const fullscreenEl = this.getFullScreenEl();

      fullscreenEl.requestFullscreen();
      this.isFullscreen = true;
    },
    /**
     * 退出全屏
     */
    exitFullscreen() {
      document.exitFullscreen();
      this.isFullscreen = false;
    },

    async handleGetWeather() {
      let cityData = await amapGetIp({
        key: "60f85fa7d1c353b0a2ffb92083e365f0",
      });
      let imgList = [
        "https://yiligps.oss-cn-shenzhen.aliyuncs.com/ui-show/rain1.png", //小雨
        "https://yiligps.oss-cn-shenzhen.aliyuncs.com/ui-show/rain2.png", //大雨
        "https://yiligps.oss-cn-shenzhen.aliyuncs.com/ui-show/rain3.png", // 雷雨
        "https://yiligps.oss-cn-shenzhen.aliyuncs.com/ui-show/cloud.png", //多云
        "https://yiligps.oss-cn-shenzhen.aliyuncs.com/ui-show/snow.png", //雪
        "https://yiligps.oss-cn-shenzhen.aliyuncs.com/ui-show/clear.png", // 晴
      ];
      //  {city: cityData.city}
      weatherInfo({
        key: "60f85fa7d1c353b0a2ffb92083e365f0",
        city: cityData.adcode,
      }).then((res) => {
        let weatherData = res.lives[0];
        // let high = weatherData.high.split(' ')[1];
        // let low = weatherData.low.split(' ')[1];
        this.weatherArea = cityData.city;
        this.weatherText =
          weatherData.temperature + "°" + " " + weatherData.weather;
        if (weatherData.weather.indexOf("雷") > -1) {
          this.weatherImg = imgList[2];
        } else if (weatherData.weather.indexOf("大雨") > -1) {
          this.weatherImg = imgList[1];
        } else if (weatherData.weather.indexOf("雨") > -1) {
          this.weatherImg = imgList[0];
        } else if (weatherData.weather.indexOf("雪") > -1) {
          this.weatherImg = imgList[4];
        } else if (weatherData.weather.indexOf("晴") > -1) {
          this.weatherImg = imgList[5];
        } else if (weatherData.weather.indexOf("云") > -1) {
          this.weatherImg = imgList[3];
        } else {
          this.weatherImg = imgList[3];
        }
      });
    },
    handleGoPath(path) {
      if (!path) {
        this.$router.go(-1);
      }
      this.$router.push({
        path,
      });
    },
    onMapLoad(e) {
      console.log(e, "---地图加载完成---");
    },
    onMarkerClick(e) {
      this.infoVisible = true;
      this.currentVehicle = e.data;
      console.log(e, "---点击标点---");
    },
    vehicleIconName(val, current) {
      return require(`../../../assets/images/OperationBigScreen/MapEvents/marker-icon-${current}.png`);
    },
    handlePointRender(context) {
      this.handleSetPointRender(context, 0);
    },
    handlePointRender1(context) {
      this.handleSetPointRender(context, 2);
    },
    handleSetPointRender(context, type) {
      const size = 50;
      let div = document.createElement("div");
      div.style.backgroundImage = `url(https://yili-platform-v2.oss-cn-shenzhen.aliyuncs.com/common/bigScreenUI/mapui/clusterer-${type}.png)`;
      div.style.backgroundSize = "100%";
      div.style.width = "56px";
      div.style.height = "62px";
      div.innerHTML = context.count;
      div.style.lineHeight = "62px";
      div.style.color = "#fff";
      div.style.fontSize = "16px";
      div.style.fontWeight = 500;
      div.style.textAlign = "center";
      context.marker.setOffset(new AMap.Pixel(-56 / 2, -62 / 2));
      context.marker.setContent(div);
    },
    ...mapMutations(["SetFullscreen"]),
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
::v-deep .amap-maptypecontrol {
  display: none;
}
::v-deep .amap-controls {
  display: none;
}
::v-deep .WindowContent {
  background-color: transparent;
  border: none;
}
::v-deep .AnchorArrow {
  display: none;
}
</style>
